// extracted by mini-css-extract-plugin
export default {"title":"cuW7l0g5wr","title_isExpandable":"DHgim5LJau","titleText":"toV43N8oDE","titleIcon":"Qkq3yKt_EM","noVotes":"OOH9hD4XNt"};